import React from 'react';
import Framework from '@beardeddevops/react.framework';
import SidenavContent from './SidenavContent';
import SidenavContentLegacy from './SidenavContentLegacy';
import {resolveUseNewSidenav} from 'utils/sidenavOverride';
import PropTypes from "prop-types";

const FrameworkSideBar = Framework.Components.withRootState(Framework.Components.SideBar);

class Sidebar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			sidebarCollapsed: false,
		}
	}

	static propTypes = {
		locations: PropTypes.number,
		sessions: PropTypes.number,
		items: PropTypes.number,
		ffl_boss_linked: PropTypes.bool,
		use_new_sidenav: PropTypes.bool
	};

	render() {
		let props = this.props;
		const {sidebarCollapsed} = this.state;
		// Account customization use_new_sidenav=true enables the new sidenav; false keeps the legacy menu.
		// localStorage override_new_sidenav (Ctrl+Alt+N) takes priority for dev testing.
		const useNewSidenav = resolveUseNewSidenav(props.use_new_sidenav);

		let link = "https://fflsoftwarepro.freshdesk.com/support/tickets/new";
		if (window.isTacticalPay) {
			link = "https://www.tacticalpay.com/support/";
		}

		if (!useNewSidenav) {
			return (
				<FrameworkSideBar
					footerLink={link}
					clickOutside={false}
					{...props}
				>
					<SidenavContentLegacy {...props} />
				</FrameworkSideBar>
			);
		}

		return (
			<FrameworkSideBar
				footerLink={link}
				clickOutside={false}
				customLayout={true}
				sidebarCollapsed={sidebarCollapsed}
				{...props}
			>
				<SidenavContent
					customLayout={true}
					onCollapse={(isCollapsed) => {
						this.setState({sidebarCollapsed: isCollapsed});
						if (typeof this.props.onCollapseChange === 'function') {
							this.props.onCollapseChange(isCollapsed);
						}
					}}
					{...props}
				/>
			</FrameworkSideBar>
		);
	}
}

export default Sidebar;

